import Button from "../../../../../components/button/button.jsx";
import {FaEdit, FaPlus, FaTrash} from "react-icons/fa";
import InputForm from "../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputDateTime from "../../../../../components/input/input-datetime.jsx";
import {FaRotateRight} from "react-icons/fa6";
import {useState} from "react";
import {Modal} from "../../../../../components/modal/modal.jsx";
import { v4 as uuidv4 } from "uuid";
import {useGeneralInputSpecialCase} from "../../../../../hooks/use-general-input.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {validateEquipmentsFields} from "../../janitorial-utils.js";

const addOperations = [
  {value: 'INSTALLATION', label: 'Instalação'}
]

const destroyOperations = [
  {value: 'DAMAGED', label: 'Danificado'},
  {value: 'NOT_FOUND', label: 'Não encontrado'},
  {value: 'WITHDRAWAL', label: 'Retirada'}
]
const JanitorialItemList = ({items, setItems, operation = "ADD", agents, equipments }) => {
  const [showModal, setShowModal] = useState(false);
  const [toBeRemoved, setToBeRemoved] = useState({});
  const [currentAction, setCurrentAction] = useState("Remover equipamento");
  const handleSpecialInput = useGeneralInputSpecialCase(setToBeRemoved);
  const updateItemField = (identifier, field, value) => {
    setItems(prev =>
      prev.map(item =>
        (item.tempId ?? item.id) === identifier
          ? { ...item, [field]: value }
          : item
      )
    );
  };
  const prepareItemToRemove = (item) => {
    setCurrentAction("Remover equipamento");
    setToBeRemoved({...item, quantity: "", action: "", date: null, user: ""});
    setShowModal(true);
  }

  const prepareItemToEdit = (item) => {
    setCurrentAction("Editar item removido");
    setToBeRemoved(item);
    setShowModal(true);
  }

  const checkItems = (toCompareItem) => {
    const addedQuantity = items.reduce((acc, item) => {
      return item.item === toCompareItem.item && item.action === "INSTALLATION"
        ? acc + Number(item.quantity)
        : acc;
    }, 0);

    const removedQuantity = items.reduce((acc, item) => {
      return item.item === toCompareItem.item && item.action !== "INSTALLATION"
        ? acc + Number(item.quantity)
        : acc;
    }, 0);

    return addedQuantity > removedQuantity;
  };

  const itemForm = (item) =>
    <li key={item.tempId ?? item.id} className="flex flex-wrap w-full gap-4 mb-2">
      <div className="flex-3 min-w-[160px]">
        <SelectComponent
          id={`${item.tempId ?? item.id}-item`}
          isDisabled={operation !== "ADD"}
          options={equipments}
          label={`Item ${operation === 'ADD' ? " *" : ""}`}
          value={equipments.find(equipment => equipment.value === item.item) ?? undefined}
          onChange={option =>
            updateItemField(item.tempId ?? item.id, "item", option?.value)
          }
        />
      </div>
      <div className="flex-2 min-w-[120px]">
        {
          operation === "ADD"
          ? <SelectComponent
              id={`${item.tempId ?? item.id}-operation`}
              options={addOperations}
              label={`Operação ${operation === 'ADD' ? " *" : ""}`}
              value={addOperations.find(operation => operation.value === item.action)}
            />
          : <SelectComponent
              id={`${item.tempId ?? item.id}-operation`}
              isDisabled={operation !== "ADD"}
              options={destroyOperations}
              label={`Operação ${operation === 'ADD' ? " *" : ""}`}
              value={destroyOperations.find(operation => operation.value === item.action) ?? undefined}
              onChange={option =>
                updateItemField(item.tempId ?? item.id, "action", option?.value)
              }
            />
        }
      </div>
      <div className="flex-2 min-w-[120px]">
        <SelectComponent
          id={`${item.tempId ?? item.id}-agent`}
          isDisabled={operation !== "ADD"}
          options={agents}
          label={`Usuário ${operation === 'ADD' ? " *" : ""}`}
          value={agents.find(agent => agent.value === Number(item.user)) ?? undefined}
          onChange={(option) =>
            updateItemField(item.tempId ?? item.id, "user", option?.value)
          }
        />
      </div>
      <div className="flex-2 min-w-[120px]">
        <InputDateTime
          id={`${item.tempId ?? item.id}-date`}
          disabled={operation !== "ADD"}
          label={`Data/hora ${operation === 'ADD' ? " *" : ""}`}
          onChange={(date) =>
            updateItemField(item.tempId ?? item.id, "date", date)
          }
          selected={item.date}
        />
      </div>
      <div className="flex-1 min-w-[90px]">
        <InputForm
          id={`${item.tempId ?? item.id}-quantity`}
          disabled={operation !== "ADD"}
          label={`Quantidade ${operation === 'ADD' ? " *" : ""}`}
          type="number"
          min={0}
          value={item.quantity}
          onKeyDown={(e) => {
            if (["-", "e", "E", "+", ".", ","].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={({target}) => {
            const positiveValue = target.value.replace(/\D/g, "");
            updateItemField(item.tempId ?? item.id, "quantity", positiveValue);
          }}
        />
      </div>
      {operation === "ADD" &&
        <div>
          <div className="flex gap-2">
            <Button disabled={!item.id || !checkItems(item)} onClick={() => prepareItemToRemove(item)}><FaRotateRight/> Remover</Button>
            <Button onClick={() => setItems(prev => prev.filter(el => el.id ? el.id !== item.id : el.tempId !== item.tempId))} target="danger" title="Remover item"><FaTrash/></Button>
          </div>
        </div>
      }
      {(operation !== "ADD" && operation !== "") && <Button disabled={!item.tempId} onClick={() => prepareItemToEdit(item)}><FaEdit/></Button>
      }
    </li>

  const validateDestroyPossibility = () => {
    return validateEquipmentsFields([toBeRemoved]);
  }

  const handleEquipmentAction = () => {
    const isValid = validateDestroyPossibility()

    if(isValid) {
      projectUtils.swalErrorMessage("", isValid, "Ok")
      return;
    }

    const toRemoveQuantity = toBeRemoved.quantity;
    const addedQuantity = items.reduce((acc, item) => {
      return item.item === toBeRemoved.item && item.action === "INSTALLATION"
        ? acc + Number(item.quantity)
        : acc
    }, 0)
    const removedQuantity = items.reduce((acc, item) => {
      return item.item === toBeRemoved.item && item.action !== "INSTALLATION" && item.tempId !== toBeRemoved.tempId
        ? acc + Number(item.quantity)
        : acc
    }, 0)
    const totalAvailable = addedQuantity - removedQuantity;

    if(toRemoveQuantity > totalAvailable){
      projectUtils.swalErrorMessage("", "A quantidade informada excede a quantidade disponível.");
      return;
    }

    if(currentAction === "Remover equipamento"){
      setItems(prev => [...prev, {tempId: uuidv4(), item: toBeRemoved.item, quantity: toBeRemoved.quantity, action: toBeRemoved.action, date: toBeRemoved.date, user: toBeRemoved.user}]);
    }
    else {
      setItems(prev => prev.map(el => {
          return toBeRemoved.tempId === el.tempId
            ? {tempId: toBeRemoved.tempId, item: toBeRemoved.item, quantity: toBeRemoved.quantity, action: toBeRemoved.action, date: toBeRemoved.date, user: toBeRemoved.user}
            : el
        }
      ));
    }
    setCurrentAction("Remover equipamento");
    setShowModal(false);
    setToBeRemoved(null);
  }

  return(
    <>
      <ul className="flex flex-col gap-2">
        { operation === "ADD"
          ? items.filter(el => el.action === "INSTALLATION" || el.action === "").map((el) => itemForm(el))
          : items.filter(el => el.action !== "INSTALLATION").map((el) => itemForm(el))
        }
      </ul>
      {
        operation === "ADD" &&
        <Button onClick={() =>
            setItems(prev => [...prev, {tempId: uuidv4(), item: "", user: "", action: "INSTALLATION", date: null, quantity: ""}])}><FaPlus/>
            Adicionar equipamento
        </Button>
      }
      <Modal open={showModal} setOpen={() => {setShowModal(false); setToBeRemoved(null)}} title={currentAction} overflow={true}>
        <Modal.Body>
          <div className="grid grid-cols-12 w-full gap-6">
            <div className="col-span-3">
              <SelectComponent
                id={`toBeRemoved-item`}
                options={equipments.filter(equipment => equipment.value === toBeRemoved?.item)}
                label="Item *"
                value={equipments.find(equipment => equipment.value === toBeRemoved?.item) ?? undefined}
              />
            </div>
            <div className="col-span-3">
                 <SelectComponent
                    id={`$toBeRemoved-operation`}
                    options={destroyOperations}
                    label="Operação *"
                    value={destroyOperations.find(operation => operation.value === toBeRemoved?.action) ?? undefined}
                    onChange={(option) =>
                      handleSpecialInput("action", option?.value)
                    }
                  />
            </div>
            <div className="col-span-2">
              <SelectComponent
                id={`toBeRemoved-agent`}
                options={agents}
                label="Usuário *"
                value={agents.find(agent => agent.value === Number(toBeRemoved?.user)) ?? undefined}
                onChange={(option) =>
                  handleSpecialInput("user", option?.value)
                }
              />
            </div>
            <div className="col-span-2">
              <InputDateTime
                id={`toBeRemoved-date`}
                label="Data/hora *"
                onChange={(date) =>
                  handleSpecialInput("date", date)
                }
                selected={toBeRemoved?.date}
              />
            </div>
            <div className="col-span-2">
              <InputForm
                id={`toBeRemoved-quantity`}
                label="Quantidade *"
                type="number"
                value={toBeRemoved?.quantity}
                onKeyDown={(e) => {
                  if (["-", "e", "E", "+", ".", ","].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={({target}) => {
                  const positiveValue = target.value.replace(/\D/g, "");
                  handleSpecialInput("quantity", positiveValue)
                }
                }
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleEquipmentAction}>Confirmar</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default JanitorialItemList